import styled from 'styled-components';

const PanelContainer = styled.div<{ $position: 'right' | 'bottom' }>`
  position: fixed;
  pointer-events: none;
  z-index: 99;
  ${({ $position }) => $position === 'bottom' ? `
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
  ` : `
    top: 0;
    right: 0;
    height: 100vh;
  `}
`;

const PanelContent = styled.div<{ $open: boolean; $position: 'right' | 'bottom' }>`
  pointer-events: auto;
  height: 100vh;
  width: 332px;
  background: var(--modalBgColor);
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
  padding: 0;
  transition: transform 0.45s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  ${({ $position }) => $position === 'bottom' ? `
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    max-height: 70vh;
    min-height: 0;
    border-radius: 0;
  ` : `
    height: 100vh;
    width: 332px;
  `}
  transform: ${({ $open, $position }) => {
		if ($position === 'bottom') {
			return $open ? 'translate3d(0, 0, 0)' : 'translate3d(0, 100%, 0)';
		}
		return $open ? 'translate3d(0, 0, 0)' : 'translate3d(100%, 0, 0)';
	}};
`;

const ModalContent = styled.div`
  width: 100%;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  padding: .75rem 1rem;
  min-height: 36px;
	background: var(--surfaceColor);
	color: var(--labelValueColor);

`;

const Main = styled.div`
  overflow-y: auto;
  height: calc(100% - 100px);
  // padding-right: 0.5rem;
  [data-position='bottom'] & {
    height: auto;
    max-height: calc(70vh - 100px);
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px transparent;
    border-radius: 3px;
    background-color: var(--scrollbarTrackColor);
  }

  &::-webkit-scrollbar {
    width: 8px;
    background-color: var(--scrollbarTrackColor);
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    box-shadow: inset 0 0 6px transparent;
    background-color: rgb(211, 211, 211);
  }
`;

const Title = styled.div`
  color: var(--labelValueColor);
  font-size: 1.25rem;
  font-family: 'Inter';
  font-weight: 400;
`;

const Buttons = styled.div`
  display: flex;
  gap: 0.5rem;
	align-items: center;
  button {
    outline: none;
  }

  #close {
    background: var(--defaultBgColor);
    color: var(--textTitleColor);
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
		#side-modal-close{
			height: auto;
			padding: 0.45rem 0.72rem;
			line-height: 1;
			font-size: 14px;
			min-height: 34px;

		}

`;

export {
	PanelContainer,
	PanelContent,
	ModalContent,
	Title,
	Main,
	Header,
	Buttons,
};
